<template>
  <div class="mb-pagination w-full text-center mt-10">
    <div class="text-left">
      <button v-if="showPreviousButton"
        type="button"
        class="btn-outlined btn btn-secondary"
        @click="showPreviousPage">
        Previous
      </button>
    </div>
    <div class="font-medium pt-3">
      {{ mobilePaginationStatus }}
    </div>
    <div class="text-right">
      <button v-if="showNextButton"
        type="button"
        class="btn-outlined btn btn-secondary"
        @click="showNextPage">
        Next
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['paginationInfo'],
  computed: {
    mobilePaginationStatus () {
      const { page, per_page, total } = this.paginationInfo
      const maxPage = Math.ceil(total / per_page)

      return `Page ${page} of ${maxPage}`
    },
    showPreviousButton () {
      const { page } = this.paginationInfo

      return page > 1
    },
    showNextButton () {
      const { page, per_page, total } = this.paginationInfo
      const maxPage = Math.ceil(total / per_page)

      return page < maxPage
    }
  },
  methods: {
    showPreviousPage () {
      const { page } = this.paginationInfo

      this.$store.commit('setPage', page - 1)
      window.scrollToElement('.search-result')
    },
    showNextPage () {
      const { page } = this.paginationInfo

      this.$store.commit('setPage', page + 1)
      window.scrollToElement('.search-result')
    }
  }
}
</script>

<style scoped>
.mb-pagination {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
}
</style>